import { render } from "./CartHeaderPage.vue?vue&type=template&id=6d4b3b3c"
import script from "./CartHeaderPage.vue?vue&type=script&lang=js"
export * from "./CartHeaderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__